import { $$ } from '@zimpa/dom';
import { $ } from '@zimpa/dom';

const KNOWLEDGE_BASE_CONTAINER_SELECTOR = '.js-knowledge-base-container';
const KNOWLEDGE_BASE_KEYWORD_SEARCH_SELECTOR = '.js-knowledge-base__keyword_search';
const KNOWLEDGE_BASE_FORM_SELECTOR = '.js-knowledge-base-form';

class KnowledgeBase {
    private readonly _knowledge_base_container: HTMLDivElement;
    private readonly _knowledge_base_keyword_search: HTMLInputElement;
    private readonly _knowledge_base_form: HTMLFormElement;
    public constructor(el: HTMLElement) {
        this._knowledge_base_container = <HTMLDivElement>$(KNOWLEDGE_BASE_CONTAINER_SELECTOR, el);
        this._knowledge_base_keyword_search = <HTMLInputElement>$(KNOWLEDGE_BASE_KEYWORD_SEARCH_SELECTOR, el);
        this._knowledge_base_form = <HTMLFormElement>$(KNOWLEDGE_BASE_FORM_SELECTOR, el);
        this.handleItem();
    }
    private handleItem() {
        this._knowledge_base_keyword_search.addEventListener('keydown', (event): void => {
            if (event.code === 'Enter'){
                event.preventDefault();
                this._knowledge_base_form.submit();
            }
        });
    }
}
export function knowledgeBase(): void {
    $$(KNOWLEDGE_BASE_CONTAINER_SELECTOR).map(
        (element: HTMLElement): KnowledgeBase => {
            return new KnowledgeBase(element);
        },
    );
}
